import React from "react";
import clsx from "clsx";
import {getTextClassNameByPersonType} from "utils/driverUtils";
import {PersonType} from "types/enums/PersonType";
import FeatherIcon from "components/FeatherIcon";
import {ReservationDriver} from "types/entities/ReservationDriver";
import {PackageItem} from "types/entities/PackageItem";

interface AccessTickerDriverIconProps {
    reservationDriver: ReservationDriver | null;
    packageItem: PackageItem | null;
    isNotAbsolutePosition?: boolean;
}

const AccessTickerDriverIcon = (props: AccessTickerDriverIconProps) => {
    return (
        <div
            className={clsx(
                "AccessTickerDriverIcon flex flex-row items-center justify-center",
                props.isNotAbsolutePosition ? "" : "absolute top-0 bottom-0 left-[8px] md:left-[10px] ",
                getTextClassNameByPersonType(
                    props.reservationDriver ? props.reservationDriver.person_type : (props.packageItem?.person_type as unknown as PersonType)
                )
            )}
        >
            <FeatherIcon className={"size-[20px] md:size-[30px] flex-none"} name={"user"} strokeWidth={2} />
        </div>
    );
};

export default AccessTickerDriverIcon;